<template>
	<div>

		<div class="blue" v-if="blue"></div>

		<!--		<div class="debug-game" style="background-color: azure; padding: 10px; float: left;">-->
		<!--			<p>X: {{ currentX }}</p>-->
		<!--			<p>Y: {{ currentY }}</p>-->
		<!--			<p>fireAvailable: {{ fireAvailable ? 'YES' : 'no' }}</p>-->
		<!--			<p>barrelRotate: {{ this.barrelRotate }}</p>-->
		<!--		</div>-->

		<div class="game-wrapper">

			<table class="game-table">
				<tr v-for="y in 10" v-bind:key="y">
					<td v-for="x in 10" v-bind:key="x + '' + y">

						<div class="bullet" v-if="x === bulletX && y === bulletY" :style="{ transform: 'rotate('+bulletRotate+'deg)' }">

						</div>

						<div class="turret" v-if="x === currentX && y === currentY"
							 :style="{ transform: x === currentX && y === currentY ? 'rotate('+barrelRotate+'deg)' : '0' }">
							<div class="barrel" :style="{ top: barrelTop, transition: barrelTransition }">

							</div>
						</div>

						<div v-if="checkTarget(x, y)" class="target-wrapper">
							<!--			 :style="{ backgroundColor: getTarget(x, y)[4] }"				-->
							<div class="target" :class="{ deleted: getTarget(x, y)[3] }">

								{{ getTarget(x, y)[2] }}

							</div>
						</div>

					</td>
				</tr>
			</table>

		</div>

		<div class="game-bar" :style="{ backgroundColor: fireAvailable ? '#008f32' : '#dd5a2e' }">

			<div style="margin-left: 20px;">
				Score: {{ score }}
			</div>

			<div>

				Power: {{ bulletPower }}

			</div>

			<div style="float: right; margin-right: 20px;">
				Level: {{ level }}
			</div>

		</div>

	</div>
</template>

<style lang="scss">

	body {
		margin: 0;
		padding: 0;
		font-family: Tahoma, sans-serif;
	}

	.bullet {
		position: absolute;
		width: 100%;
		height: 100%;
		left: 0;
		top: 0;

		background-image: url("../assets/retina/bulletGreen3_outline.png");
		background-size: 12%;
		background-repeat: no-repeat;
		background-position-x: 50%;
		background-position-y: 50%;
	}

	.target-wrapper {
		position: absolute;
		width: 100%;
		height: 100%;
		left: 0;
		top: 0;
	}

	.target {
		position: absolute;
		/*background-color: #dd5a2e;*/
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		/*-webkit-border-radius: 100%;*/
		/*-moz-border-radius: 100%;*/
		/*border-radius: 100%;*/

		line-height: 60px;
		color: #ffffff;
		text-align: center;
		font-weight: bold;
		font-size: 18px;

		/*transition: background-color 1000ms ease-in-out;*/

		background-image: url("../assets/retina/tank_red.png");
		background-size: 50%;
		background-repeat: no-repeat;
		background-position-x: 50%;
		background-position-y: 50%;

		&.deleted {
			/*background-color: transparent;*/
		}
	}

	.turret {
		width: 100%;
		height: 100%;
		margin: auto auto;

		background-image: url("../assets/retina/tankBody_green_outline.png");
		background-size: 50%;
		background-repeat: no-repeat;
		background-position-x: 50%;
		background-position-y: 50%;

		.barrel {
			position: absolute;
			top: 0;

			width: 14px;
			height: 60%;
			left: 47%;

			margin-left: -4px;


			background-image: url("../assets/retina/tankGreen_barrel2_outline.png");
			background-size: 100%;
			background-repeat: no-repeat;
			background-position-x: 50%;
			background-position-y: 50%;
		}
	}


	.game-wrapper {
		margin: 20px auto 0 auto;
		width: 800px;
		height: 800px;
		border: 1px dashed #285573;
	}

	.game-bar {
		margin: 10px auto 0 auto;
		width: 800px;
		height: 40px;
		border: 1px dashed rgba(0, 0, 0, 0.99);

		color: #ffffff;

		font-size: 20px;
		line-height: 40px;

		display: flex;
		justify-content: space-between;
	}

	.game-table {
		width: 100%;
		height: 100%;

		border-spacing: 0;

		td {

			padding: 0;

			background-image: url("../assets/retina/tileSand1.png");

			width: 80px;
			height: 80px;

			position: relative;
			text-align: center;
		}
	}

	.blue {
		position: fixed;
		top: 0;
		left: 0;

		height: 100%;
		width: 100%;
		z-index: 9000;

		background-image: url("../assets/blue.jpg");
		background-color: #1F67B1;
		background-size: 100%;
		background-repeat: no-repeat;
	}
</style>

<script>
	export default {
		name: 'home',
		data: () => {
			return {
				currentX: 2,
				currentY: 9,

				barrelRotate: 0,
				barrelTop: '0',
				barrelTransition: 'none',
				fireAvailable: true,

				bulletX: -1,
				bulletY: -1,
				bulletRotate: 0,

				targets: [
					[2, 2, 10, false, '#dd001a'],
					[2, 3, 1, false, '#dd5a2e'],
					[2, 4, 1, false, '#dd5a2e'],

					[5, 4, 1, false, '#dd5a2e'],
					[6, 5, 2, false, '#dd5a2e'],
					[9, 9, 1, false, '#dd5a2e'],

					[7, 4, 1, false, '#dd5a2e'],
					[8, 4, 2, false, '#dd5a2e'],
					[9, 4, 1, false, '#dd5a2e'],
				],

				score: 0,
				level: 1,

				bulletContent: 'a',
				bulletPower: 1,

				blue: false,
			};
		},
		watch: {
			score: function () {
				if (this.score > 19) {
					this.level = 2;
					this.bulletContent = 'aa';
					this.bulletPower = 2;
				}

				if (this.score > 149) {
					this.level = 3;
					this.bulletContent = 'aaa';
					this.bulletPower = 5;
				}

				if (this.score > 249) {
					this.level = 4;
					this.bulletContent = 'aa kiki';
					this.bulletPower = 10;
				}

				if (this.score > 499) {
					this.level = 5;
				}

				if (2 === this.level && 0 === this.targets.length) {
					this.targets = [
						[8, 2, 10, false, '#dd001a'],
						[8, 3, 15, false, '#dd5a2e'],
						[8, 4, 10, false, '#dd001a'],

						[5, 3, 10, false, '#dd001a'],
						[6, 7, 50, false, '#dd8f00'],
						[9, 1, 10, false, '#dd001a'],

						[7, 2, 10, false, '#dd001a'],
						[8, 2, 20, false, '#dd5a2e'],
						[9, 2, 15, false, '#dd5a2e'],
					];
				}

				if (3 === this.level && 0 === this.targets.length) {
					this.targets = [
						[1, 1, 100, false, '#af00dd'],
					];
				}

				if (4 === this.level && 0 === this.targets.length) {
					this.targets = [
						[1, 1, 250, false, '#422121'],
					];
				}

				if (5 === this.level) {
					this.blue = true;
				}
			}
		},
		created: function () {
			window.addEventListener('keydown', this.onkey);
		},
		beforeDestroy: function () {
			window.removeEventListener('keydown', this.onkey);
		},
		methods: {
			checkTarget: function (x, y) {

				for (let i = 0; i < this.targets.length; i++) {

					if (x === this.targets[i][0] && y === this.targets[i][1]) {
						return true;
					}

				}

				return false;

			},
			getTarget: function (x, y) {

				for (let i = 0; i < this.targets.length; i++) {

					if (x === this.targets[i][0] && y === this.targets[i][1]) {
						return this.targets[i];
					}

				}

				return false;

			},
			setTarget: function (x, y, target) {

				for (let i = 0; i < this.targets.length; i++) {

					if (x === this.targets[i][0] && y === this.targets[i][1]) {

						this.targets[i] = target;
					}

				}

			},
			deleteTarget: function (x, y, target) {

				//console.log(x, y, target);

				target[3] = true;

				this.setTarget(x, y, target);

				for (let i = 0; i < this.targets.length; i++) {

					if (x === this.targets[i][0] && y === this.targets[i][1]) {

						let thatThis = this;

						thatThis.targets.splice(i, 1); // todo, race condition oluyor, burası aşağısı ile değişmeli

						// setTimeout(function () {
						// 	thatThis.targets.splice(i, 1);
						// }, 1000);
					}

				}

			},
			onkey: function (event) {
				switch (event.code) {
					case 'Space':

						if (document.fullscreenEnabled) {
							document.getElementById('app').requestFullscreen();
						}

						if (false === this.fireAvailable) return;

						switch (this.barrelRotate) {
							case 90: // right

								if (this.currentX < 10) {

									this.fireAvailable = false;

									let thatThis = this;

									this.barrelTransition = 'none';
									this.barrelTop = '5px';

									setTimeout(function () {
										thatThis.barrelTransition = 'top 200ms ease-in';
										thatThis.barrelTop = '0';
									}, 100);

									this.bulletY = this.currentY;
									this.bulletRotate = parseInt(this.barrelRotate);

									let counter = 1;

									for (let i = this.currentX + 1; i <= 10; i++) {

										setTimeout(function () {
											thatThis.bulletX = i;

											if (thatThis.checkTarget(thatThis.bulletX, thatThis.bulletY)) {
												let target = thatThis.getTarget(thatThis.bulletX, thatThis.bulletY);

												if (target[2] > 0) {
													target[2] -= thatThis.bulletPower;
													thatThis.score += thatThis.bulletPower;
												} else {
													return;
												}

												if (target[2] < 1) {
													thatThis.deleteTarget(thatThis.bulletX, thatThis.bulletY, target);
												}

												thatThis.setTarget(thatThis.bulletX, thatThis.bulletY, target);

											}

										}, 100 * counter);

										counter++;
									}

									setTimeout(function () {
										thatThis.bulletY = -1;
										thatThis.bulletX = -1;
										thatThis.fireAvailable = true;
									}, 100 * counter);
								}

								break;
							case 270: // left

								if (this.currentX > 1) {

									this.fireAvailable = false;

									let thatThis = this;

									this.barrelTransition = 'none';
									this.barrelTop = '5px';

									setTimeout(function () {
										thatThis.barrelTransition = 'top 200ms ease-in';
										thatThis.barrelTop = '0';
									}, 100);

									this.bulletY = this.currentY;
									this.bulletRotate = parseInt(this.barrelRotate);

									let counter = 1;

									for (let i = this.currentX - 1; i > 0; i--) {

										setTimeout(function () {
											thatThis.bulletX = i;

											if (thatThis.checkTarget(thatThis.bulletX, thatThis.bulletY)) {
												let target = thatThis.getTarget(thatThis.bulletX, thatThis.bulletY);

												if (target[2] > 0) {
													target[2] -= thatThis.bulletPower;
													thatThis.score += thatThis.bulletPower;
												} else {
													return;
												}

												if (target[2] < 1) {
													thatThis.deleteTarget(thatThis.bulletX, thatThis.bulletY, target);
												}

												thatThis.setTarget(thatThis.bulletX, thatThis.bulletY, target);

											}

										}, 100 * counter);

										counter++;
									}

									setTimeout(function () {
										thatThis.bulletY = -1;
										thatThis.bulletX = -1;
										thatThis.fireAvailable = true;
									}, 100 * counter);
								}

								break;
							case 180: // down

								if (this.currentY < 10) {

									this.fireAvailable = false;

									let thatThis = this;

									this.barrelTransition = 'none';
									this.barrelTop = '5px';

									setTimeout(function () {
										thatThis.barrelTransition = 'top 200ms ease-in';
										thatThis.barrelTop = '0';
									}, 100);

									this.bulletX = this.currentX;
									this.bulletRotate = parseInt(this.barrelRotate);

									let counter = 1;

									for (let i = this.currentY + 1; i <= 10; i++) {

										setTimeout(function () {
											thatThis.bulletY = i;

											if (thatThis.checkTarget(thatThis.bulletX, thatThis.bulletY)) {
												let target = thatThis.getTarget(thatThis.bulletX, thatThis.bulletY);

												if (target[2] > 0) {
													target[2] -= thatThis.bulletPower;
													thatThis.score += thatThis.bulletPower;
												} else {
													return;
												}

												if (target[2] < 1) {
													thatThis.deleteTarget(thatThis.bulletX, thatThis.bulletY, target);
												}

												thatThis.setTarget(thatThis.bulletX, thatThis.bulletY, target);

											}

										}, 100 * counter);

										counter++;
									}

									setTimeout(function () {
										thatThis.bulletY = -1;
										thatThis.bulletX = -1;
										thatThis.fireAvailable = true;
									}, 100 * counter);
								}

								break;
							case 0: // up

								if (this.currentY > 1) {

									this.fireAvailable = false;

									let thatThis = this;

									this.barrelTransition = 'none';
									this.barrelTop = '5px';

									setTimeout(function () {
										thatThis.barrelTransition = 'top 200ms ease-in';
										thatThis.barrelTop = '0';
									}, 100);

									this.bulletX = this.currentX;
									this.bulletRotate = parseInt(this.barrelRotate);

									let counter = 1;

									for (let i = this.currentY - 1; i > 0; i--) {

										setTimeout(function () {
											thatThis.bulletY = i;

											if (thatThis.checkTarget(thatThis.bulletX, thatThis.bulletY)) {
												let target = thatThis.getTarget(thatThis.bulletX, thatThis.bulletY);

												if (target[2] > 0) {
													target[2] -= thatThis.bulletPower;
													thatThis.score += thatThis.bulletPower;
												} else {
													return;
												}

												if (target[2] < 1) {
													thatThis.deleteTarget(thatThis.bulletX, thatThis.bulletY, target);
												}

												thatThis.setTarget(thatThis.bulletX, thatThis.bulletY, target);

											}

										}, 100 * counter);

										counter++;
									}

									setTimeout(function () {
										thatThis.bulletY = -1;
										thatThis.bulletX = -1;
										thatThis.fireAvailable = true;
									}, 100 * counter);
								}

								break;
						}

						break;
					case 'ArrowUp':
						if (this.barrelRotate === 0 && this.currentY > 1) this.currentY--;
						this.barrelRotate = 0;
						break;
					case 'ArrowDown':
						if (this.barrelRotate === 180 && this.currentY < 10) this.currentY++;
						this.barrelRotate = 180;
						break;
					case 'ArrowLeft':
						if (this.barrelRotate === 270 && this.currentX > 1) this.currentX--;
						this.barrelRotate = 270;
						break;
					case 'ArrowRight':
						if (this.barrelRotate === 90 && this.currentX < 10) this.currentX++;
						this.barrelRotate = 90;
						break;
				}
			}
		}
	};
</script>
